import {
    componentService,
    element as $,
    elements as $$,
    FormComponent,
    requestService,
} from '@contorion/core';
import { IGa4AddToCart } from "../../google/interfaces/ga4-event.interface";
import { ga4EventService } from "../../google/services/ga4-event.service";
import { algoliaService } from '../../../modules/algolia/services/algolia.service';

const SELECTOR_TOTAL_COUNT: string = '.js-cart-total-count';
const SELECTOR_TOTAL_COUNT_BADGE: string = '.js-cartItemCount';
const URL_PATH_CART: string = '/cart';
const CLASS_OVERFLOW_HIDDEN: string = 'overflow--hidden';
const BUNDLE_PRODUCT_ITEM: string = 'Set'

export class AddToCartFormComponent extends FormComponent {
    private mapFormDataToGA4AddToCartEventData(data: FormData): IGa4AddToCart {
        const addToCartEventData: IGa4AddToCart = {
            currency: window.tc_vars?.product_currency,
            value: 0,
            items: [{
                index: 0,
                item_id: '',
                item_name: '',
                price: 0,
                quantity: 0,
            }]
        };
        data.forEach((value: string, key: string) => {
            switch (key) {
                case 'sku': {
                    addToCartEventData.items[0].item_id = value;
                    break;
                }
                case 'name': {
                    addToCartEventData.items[0].item_name = value;
                    break;
                }
                case 'price': {
                    // parse the price(ex: 3.122,64 €)
                    const price =  parseInt(
                        value.replace(".", "")
                            .replace(",", "")
                    ) / 100
                    addToCartEventData.items[0].price = price;
                    addToCartEventData.value = price;
                    break;
                }
                case 'quantity': {
                    addToCartEventData.items[0].quantity = parseInt(value);
                }
            }
        });

        return addToCartEventData;
    }

    protected get isDirectSubmit(): boolean {
        return window.location.href.indexOf(URL_PATH_CART) !== -1;
    }

    protected get minimal(): boolean {
        return this.element.dataset.minimal !== undefined;
    }

    protected _minimalTarget: HTMLElement;

    protected get minimalTarget(): HTMLElement {
        if (this._minimalTarget !== undefined) {
            return this._minimalTarget;
        }

        const targetSelector: string = this.element.dataset.minimalTarget;
        let parentElement: HTMLElement = this.element.parentElement;
        let target: HTMLElement = null;

        while (parentElement) {
            target = <HTMLElement> $(targetSelector, parentElement);

            if (target) {
                break;
            }

            parentElement = parentElement.parentElement;
        }

        this._minimalTarget = target;

        return target;
    }

    protected bindEvents() {
        super.bindEvents();
    }

    protected getBody(): FormData {
        const body = new FormData();
        for (const element of Array.apply(null, this.element.elements)) {
            const input = <HTMLInputElement> element;
            const name = input.getAttribute('name');
            const value = input.value;
            body.append(name, value);
        }

        return body;
    }

    protected async submit(): Promise<void> {
        if (this.isDirectSubmit) {
            this.element.submit();

            return;
        }

        let url: string = this.element.action;

        if (this.minimal === true) {
            const concatChar: string = /\?/.test(url) ? '&' : '?';

            url += concatChar + 'minimal=1';
        }

        const result: string = await requestService.post(url, this.getBody())
            .then((response: Response) => response.text());

        if (this.minimal === true) {
            this.addMinimalInformation(result);
        } else {
            this.showModal(result);
        }

        // trigger gtm algolia add to cart event only when add to cart success
        if (result.includes('data-added-to-cart-success')) {
           this.fireGA4Event();
        }

        this.progress = false;
    }

    protected fireGA4Event() {
        // and is in algolia bucket
        if (this.element.dataset.isInAlgoliaBucket) {
            if (algoliaService.isAlgoliaSearch() && this.element.dataset.insightsQueryId) {
                ga4EventService.algoliaAddedToCartObjectIdsAfterSearch();
            } else {
                ga4EventService.algoliaAddedToCartObjectIds();
            }
        }

        if (window.tc_vars) {
            const isBundle = !!this.getBody().get('isBundle');
            if (isBundle || !this.element.classList.contains('quantity-widget')) {
                const addToCartEventData: IGa4AddToCart = {
                    currency: window.tc_vars.product_currency,
                    value: parseFloat(window.tc_vars.product_unitprice_ati),
                    items: ga4EventService.getProductItems()
                };
                ga4EventService.addToCart(addToCartEventData);
            } else {
                ga4EventService.addToCart(this.mapFormDataToGA4AddToCartEventData(this.getBody()));
            }
        }
    }

    protected showModal(result: string): void {
        const div: HTMLElement = document.createElement('div');
        document.body.classList.add(CLASS_OVERFLOW_HIDDEN);

        div.innerHTML = result;
        document.body.appendChild(div);
        componentService.load(div);

        const inputElement: HTMLInputElement =
            <HTMLInputElement> div.querySelector(SELECTOR_TOTAL_COUNT);

        if (inputElement) {
            this.updateTotalCount(inputElement);
        }
    }

    protected addMinimalInformation(result: string): void {
        this.minimalTarget.innerHTML = result;
    }

    protected updateTotalCount(inputElement: HTMLInputElement): void {
        $$(SELECTOR_TOTAL_COUNT_BADGE).map((element: HTMLElement) => {
            element.innerHTML = inputElement.value;
        });
    }

    protected onSubmit(e: Event): void {
        super.onSubmit(e);

        e.preventDefault();

        if (!this.isValid()) {
            return;
        }

        this.submit();
    }
}
